import { gql } from '@apollo/client';

export const CREATE_COURSE_CERTIFICATE = gql`
mutation($input: CreateCourseCertificateInput!) { 
    result: createCourseCertificate(input: $input) { 
        id
    }
}
`;